import AbstractUIActions from "../AbstractUIActions";
import {STATES} from "../../states/states";
import events from "../../events/EventsObservable";
import userActionInstance, {ACTION_EVENTS} from "../UserAction";
import {inject} from "inversify";
import SERVICE_IDENTIFIER from "../../constants/identifiers";
import IAudio from "../../engine/IAudio";
import Wallet from "../../wallet/Wallet";
import CommanderBase from "../../commander/CommanderBase";
import SystemConfig from "../../system/SystemConfig";
import SystemPlatform from "../../system/SystemPlatform";
import IStatesManager from "../../states/IStatesManager";
import BaseDOM from "../BaseDOM";
import Commander from "../../../../src/Commander";

class VLT2UIActions extends AbstractUIActions {

    private _platform: SystemPlatform;
    private dom: BaseDOM;

    constructor(
        @inject(SERVICE_IDENTIFIER.StatesManager) states: IStatesManager,
        @inject(SERVICE_IDENTIFIER.EngineAudio) audio: IAudio,
        @inject(SERVICE_IDENTIFIER.Wallet) wallet: Wallet,
        @inject(SERVICE_IDENTIFIER.Commander) commander: CommanderBase,
        @inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig,
        @inject(SERVICE_IDENTIFIER.DOM) dom: BaseDOM
    ) {

        super(states, audio, wallet, commander);

        this._platform = config.platform;
        this.dom = dom;
    }

    initKeys() {
        window.addEventListener("keydown", event => this.keydown({event}));
    }

    async keydown({event}) {

        if(!event.key) return;

        switch(event.key) {
            case "Home":
            case 'g': //service
                events.dispatch(ACTION_EVENTS.ACTION_HOME_BUTTON);
                break;

            case 'c': //cashout
                break;

            case 'i': //info
                this.keydownI();
                break;

            case 'k': //linedown
            case 'l': //lineup
                break;

            case 'v': //betdown
                this.keydownV();
                break;

            case 'b': //betup
                this.keydownB();
                break;

            case 'x': //maxbet
                this.keydownX();
                break;

            case ' ': //play
                this.keydownS({event});
                break;

            case 'a': //auto
                this.keydownA({event});
                break;
        }

    }

    keydownI() {

        let state = this.statesManager.getState();

        if(state == STATES.IDLE) {
            // TODO make infopages great again
            if(
                this._platform.getDisplaysCount() == 2 &&
                (
                    this.commander?.infoPages?.isOpen() ||
                    // @ts-ignore
                    this.commander?.infopages?.isOpen() ||
                    // @ts-ignore
                    this.commander?.InfoPages?.isOpen()
                )
            ) {
                events.dispatch(ACTION_EVENTS.ACTION_INFO_ARROW, "right");
                return;
            }

            events.dispatch(ACTION_EVENTS.ACTION_INFO_TOGGLE);
        }

    }

    keydownB() {
        let state = this.statesManager.getState();

        switch(state) {
            case STATES.IDLE:
                this.wallet.incCreditBet();
                break;
        }
    }

    keydownX() {
        let state = this.statesManager.getState();

        switch(state) {
            case STATES.IDLE:
                events.dispatch(ACTION_EVENTS.ACTION_MAXBET);
                break;
        }
    }

    keydownV() {
        let state = this.statesManager.getState();

        switch(state) {
            case STATES.IDLE:
                this.wallet.decCreditBet();
                break;
        }
    }

    async keydownS({event}) {
        let state = this.statesManager.getState();

        if(this._singleInfoOpen()) {
            this._infoCloseSpin(event);
            return;
        }

        if(this.game.isAutoRun()) {
            if(state === STATES.SKIP) {
                events.dispatch(ACTION_EVENTS.ACTION_SKIP);
                return;
            }

            if(state === STATES.SPIN) {
                events.dispatch(ACTION_EVENTS.ACTION_FORCESTOP);
                return;
            }

            return;
        }

        switch(state) {
            case STATES.PREINFO:
                events.dispatch(ACTION_EVENTS.ACTION_PREINFO_CLOSE);
                break;

            case STATES.IDLE:
                await events.dispatch(ACTION_EVENTS.ACTION_BURGER_CLOSE);
                this.clickSpin();
                break;

            default:
                this.clickSpin();
                break;
        }
    }

    async keydownA({event}) {

        let state = this.statesManager.getState();

        if(this._singleInfoOpen()) {
            this._infoCloseSpin(event);
            return;
        }

        if(this.game.autostart?.isAutostart()) {
            events.dispatch(ACTION_EVENTS.ACTION_AUTOSTART_STOP);
            return;
        }

        switch(state) {
            case STATES.IDLE:

                await events.dispatch(ACTION_EVENTS.ACTION_BURGER_CLOSE);

                this.game.autostart?.setAutostart(Infinity);
                this.clickSpin();
                break;
        }
    }

    private _singleInfoOpen(): boolean {
        return this.commander.infoPages && this.commander.infoPages.isOpen() && this._platform.getDisplaysCount() == 1;
    }

    private async _infoCloseSpin(event): Promise<any> {

        let allowedActionsTmp = this.allowedActionsDynamic;
        this.unsetAllowedActions();

        await events.dispatch(ACTION_EVENTS.ACTION_INFO_TOGGLE);
        setTimeout(() => {
            this.setAllowedAction(allowedActionsTmp);
            this.clickSpin();
        }, 100);
    }

    private clickSpin(clickSound = true) {

        for(let btnKey in this.dom.spinBtns) {
            let btn = this.dom.spinBtns[btnKey];

            if($(btn).is(":visible")) {

                let action = $(btn).data("action");
                let data = $(btn).data("data") || {};
                data.clickSound = clickSound;

                if(!this.isActionAllowed(action)) return;
                userActionInstance.trigger(action, data);
                return;
            }
        }
    }

}

export default VLT2UIActions;